module.exports = __webpack_public_path__ + "media/images/author/author-7-c20ad518692de9021a1214da4ef2a57d.jpg";